export default "__VITE_ASSET__vDk2kFb$__"